import { CloseOutlined } from '@ant-design/icons'
import { List, Select } from 'antd'
import { UserInfoLine } from './ProfilePicture'
import { uniqBy } from 'lodash'
import common from '@/utils/common'

export const MemberSelector = (props) => {
  const {
    value,
    options = [],
    placeholder = 'Search by name or emails',
  } = props || {}
  return (
    <Select
      defaultValue={[]}
      value={value}
      mode="multiple"
      className="member-selector"
      allowClear
      placeholder={placeholder}
      options={options?.filter((o) => !value?.includes(o.value))}
      {...props}
    />
  )
}

export const TagsSelector = ({
  options = [],
  onChange = () => {},
  value = [],
  placeholder = 'Search members',
}) => {
  let finalOptions = uniqBy(options, (obj) => obj.value)
  finalOptions = finalOptions?.filter((o) => !value.includes(o.value))
  return (
    <>
      <Select
        value={value}
        defaultValue={[]}
        onChange={(val) => {
          onChange(
            val?.filter((email) => {
              return common.validateEmail(email)
            })
          )
        }}
        mode="tags"
        className="member-selector"
        placeholder={placeholder}
        filterOption={(input, option) => {
          return option?.name?.toLowerCase()?.includes(input.toLowerCase())
        }}
        options={finalOptions}
      />
      {value?.length > 0 && (
        <List
          className="member-list-items"
          bordered={false}
          dataSource={value}
          renderItem={(item) => {
            const member = options.find((o) => o.value == item)
            return (
              <List.Item
                key={`memberlist_${item}`}
                actions={[
                  <CloseOutlined
                    onClick={() => onChange(value.filter((v) => v != item))}
                  />,
                ]}
              >
                {member ? (
                  member.label
                ) : (
                  <UserInfoLine
                    user={{ email: item }}
                    showLink={false}
                    showEmail={true}
                  />
                )}
              </List.Item>
            )
          }}
        />
      )}
    </>
  )
}
